export type TradeSide = "buy" | "sell"

export type FlowStepId = "connect" | "quote" | "sign" | "settle"

export type SecurityFeatureId =
  | "coldStorage"
  | "encryption"
  | "antiFraud"
  | "support"
  | "insurance"

export type OrderStatus = "completed" | "processing" | "confirmed"

export type LiveOrder = {
  id: string
  side: TradeSide
  amount: number
  address: string
  status: OrderStatus
  timestamp: string
}

export type TestimonialId = "t1" | "t2" | "t3" | "t4"

export type FaqId = "q1" | "q2" | "q3" | "q4" | "q5" | "q6"

export type Trc20AdvantageId = "speed" | "fees" | "energy" | "liquidity"

export const USDT_PRICE = 1.0002

export const coreStats = [
  { id: "users", value: 280000, suffix: "+", decimals: 0 },
  { id: "volume", value: 1.8, prefix: "$", suffix: "B", decimals: 1 },
  { id: "settlement", value: 3, suffix: "s", decimals: 0 },
  { id: "uptime", value: 99.98, suffix: "%", decimals: 2 },
] as const

export const flowSteps: FlowStepId[] = ["connect", "quote", "sign", "settle"]

export const trc20Advantages: Trc20AdvantageId[] = [
  "speed",
  "fees",
  "energy",
  "liquidity",
]

export const trc20Meta: Record<
  Trc20AdvantageId,
  { value: string }
> = {
  speed: { value: "~3s" },
  fees: { value: "< $1" },
  energy: { value: "TRC-20" },
  liquidity: { value: "24/7" },
}

export const securityFeatures: SecurityFeatureId[] = [
  "coldStorage",
  "encryption",
  "antiFraud",
  "support",
  "insurance",
]

export const liveOrders: LiveOrder[] = [
  {
    id: "TRD-8291",
    side: "buy",
    amount: 2500,
    address: "TXk9...7nQp",
    status: "completed",
    timestamp: "2 min ago",
  },
  {
    id: "TRD-8290",
    side: "sell",
    amount: 10000,
    address: "TAyz...8kLm",
    status: "processing",
    timestamp: "4 min ago",
  },
  {
    id: "TRD-8289",
    side: "buy",
    amount: 500,
    address: "T3b1...7f2a",
    status: "confirmed",
    timestamp: "6 min ago",
  },
  {
    id: "TRD-8288",
    side: "sell",
    amount: 1500,
    address: "T9d4...1b3c",
    status: "completed",
    timestamp: "8 min ago",
  },
  {
    id: "TRD-8287",
    side: "buy",
    amount: 3200,
    address: "T5f8...2d7e",
    status: "completed",
    timestamp: "11 min ago",
  },
  {
    id: "TRD-8286",
    side: "sell",
    amount: 750,
    address: "T1c6...4a9f",
    status: "processing",
    timestamp: "14 min ago",
  },
  {
    id: "TRD-8285",
    side: "buy",
    amount: 50000,
    address: "T8e3...6c1b",
    status: "confirmed",
    timestamp: "16 min ago",
  },
  {
    id: "TRD-8284",
    side: "sell",
    amount: 2000,
    address: "TPqr...3nWx",
    status: "completed",
    timestamp: "19 min ago",
  },
]

export const testimonialIds: TestimonialId[] = ["t1", "t2", "t3", "t4"]

export const faqIds: FaqId[] = ["q1", "q2", "q3", "q4", "q5", "q6"]

export const navLinks = [
  { href: "#trade", key: "trade" },
  { href: "#how-it-works", key: "howItWorks" },
  { href: "#trc20", key: "trc20" },
  { href: "#security", key: "security" },
  { href: "#faq", key: "faq" },
] as const

export function formatUsdtAmount(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount)
}
